import { http } from '@api/client';
import { paramterize, pickResponse, pickResult } from '@api/utils';
import { CompanyRequest } from '@lib/company-request';
import {
  CompanyRequestFilterParams,
  // CompanyRequestSearchResult,
  CompanyRequestResult,
  FilterResponse,
  SearchCompanyRequestQuery,
  SearchCompanyRequestResponse,
} from './types';
import { of } from 'rxjs';

/**
 * Get latest deals or search and get the fitered deals.
 * @param query The query params to pass to the url.
 */
export function search(query: SearchCompanyRequestQuery, company_vtr_id: string) {
  const params = paramterize(query);
  return http
    .get<SearchCompanyRequestResponse>(`/company-request/search/${company_vtr_id}`, {
      params,
    })
    .pipe(pickResponse());
}

/**
 * Get the deal details from the server.
 * @param id The id of the deal to get
 */
export function get(vtr_relation_id: string) {
  return http.get<CompanyRequestResult>(`/company-request/${vtr_relation_id}`).pipe(pickResult());
}

// /**
//  * Filter deals using dynamic operators.
//  * @param option Query options
//  */
// export function filter(
//   company_vtr_id: string,
//   {
//     filters = [],
//     pageSize: page_size = 10,
//     page = 1,
//     sortBy = [],
//   }: CompanyRequestFilterParams = {}
// ) {
//   const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');

//   const newFilters = filters; //updateFiltersForLinkedOperator(filters);
//   const filtersMap: Record<string, string> = newFilters.reduce(
//     (map, f) =>
//       Object.assign(map, {
//         [f.id]: Object.entries(f.value)
//           .map(([op, v]) => {
//             return op === '$bw'
//               ? `$gte|||${v[0]};$lte|||${v[1]}`
//               : op === '$in' && f.id === 'service_provided_id'
//               ? `$in|||${v
//                   .split(',')
//                   .map(v => v.split('|||')[0])
//                   .join(',')}`
//               : `${op}|||${v}`;
//           })
//           .join(';'),
//       }),
//     {}
//   );

//   const params = paramterize({ page_size, page, sort, ...filtersMap });

//   return http
//     .get<FilterResponse>(`/company-request/search/${company_vtr_id}`, { params })
//     .pipe(pickResponse());
// }

/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: CompanyRequestFilterParams = {}) {
  const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${v.trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({
    page_size,
    page,
    sort,
    ...filtersMap,
  });

  return http.get<FilterResponse>(`/company-request/search`, { params }).pipe(pickResponse());
}

// /**
//  * Merge deals.
//  * @param data The merge request model.
//  */
// export function merge(data: DealMergeRequest) {
//   return http.put<DealResult>('/deals/related', data).pipe(pickResponse());
// }

/**
 * Updates the given deal.
 * @param deal The deal to update
 */
export function update(requestData: Partial<CompanyRequest>) {
  return http
    .put<CompanyRequestResult>(`/company-request/${requestData.vtr_id}`, requestData)
    .pipe(pickResponse());
}

/**
 * Deletes the given deal.
 * @param deal The deal id or the actual deal.
 */
export function remove(requestData: Partial<CompanyRequest>) {
  return http
    .delete<CompanyRequestResult>(
      `/company-request/${requestData.vtr_id}`
      // , {
      //   data: { vtr_id: requestData.vtr_id,
      //     delete_reason: requestData.delete_reason },
      // }
    )
    .pipe(pickResponse());
}

/**
 * Creates the given deal.
 * @param deal The deal to create
 */
export function create(requestData: CompanyRequest) {
  return http.post<CompanyRequestResult>(`/company-request`, requestData).pipe(pickResponse());
}
